export const themes = {
  safeway: {
    name: 'Safeway',
    color: 'bg-red-700',
    hover: 'hover:bg-red-800',
    text: 'text-red-700',
    border: 'border-red-700',
    logo: 'https://logo.clearbit.com/safeway.com',
    heroImage: 'https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&q=80&w=1000',
    welcome: 'Just for U',
    accent: '#b91c1c'
  },
  target: {
    name: 'Target',
    color: 'bg-red-600',
    hover: 'hover:bg-red-700',
    text: 'text-red-600',
    border: 'border-red-600',
    logo: 'https://logo.clearbit.com/target.com',
    heroImage: 'https://images.unsplash.com/photo-1550989460-0adf9ea622e2?auto=format&fit=crop&q=80&w=1000',
    welcome: 'Target Circle',
    accent: '#dc2626'
  },
  homedepot: {
    name: 'Home Depot',
    color: 'bg-orange-600',
    hover: 'hover:bg-orange-700',
    text: 'text-orange-600',
    border: 'border-orange-600',
    logo: 'https://logo.clearbit.com/homedepot.com',
    heroImage: 'https://images.unsplash.com/photo-1518737003272-da7797797aca?auto=format&fit=crop&q=80&w=1000',
    welcome: 'More Saving. More Doing.',
    accent: '#ea580c'
  }
};
